// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family: "Manrope", Arial, sans-serif;
  color: #0a0f24;
}

.app-shell {
  display: grid;
  grid-template-columns: 264px minmax(0, 1fr);
  width: 100vw;
  height: 100vh;
  background: #f1f5f9;
  overflow: hidden;
}

.app-shell.sidebar-collapsed {
  grid-template-columns: 68px minmax(0, 1fr);
}

.app-sidebar {
  width: 264px;
  min-width: 264px;
  height: 100vh;
  background: #161d2f;
  border-right: 0;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  overflow: visible;
  position: relative;
  z-index: 20;
  transition: width 0.3s cubic-bezier(0.16, 1, 0.3, 1), min-width 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.app-shell.sidebar-collapsed .app-sidebar {
  width: 68px;
  min-width: 68px;
}

.sidebar-brand {
  height: 64px;
  padding: 0 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  gap: 11px;
  flex-shrink: 0;
}

.app-shell.sidebar-collapsed .sidebar-brand {
  padding: 0;
  justify-content: center;
}

.brand-logo {
  width: 36px;
  height: 36px;
  border-radius: 11px;
  background: #162d66;
  display: grid;
  place-items: center;
  overflow: hidden;
  flex: 0 0 auto;
}

.brand-logo mat-icon {
  width: 22px;
  height: 22px;
  color: #ffffff;
}

.menu-button {
  color: #7e93ad;
}

.icon-button:hover .menu-button {
  color: #ffffff;
}

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  min-width: 0;
}

.brand-text strong {
  color: #ffffff;
  font-size: 17px;
  letter-spacing: -0.02em;
  white-space: nowrap;
}

.brand-text span {
  margin-top: 3px;
  color: #7e93ad;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-nav {
  flex: 1;
  padding: 14px 12px;
  overflow-y: auto;
  overflow-x: hidden;
}
.sidebar-nav::-webkit-scrollbar {
  width: 6px;
}
.sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.16);
  border-radius: 3px;
}
.sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.app-shell.sidebar-collapsed .sidebar-nav {
  padding: 14px 12px;
}

.nav-group {
  margin-bottom: 4px;
  position: relative;
}

.app-shell.sidebar-collapsed .nav-group + .nav-group::before {
  content: "";
  display: block;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 6px 8px;
}

.nav-item,
.submenu-item {
  border: 0;
  background: transparent;
  font: inherit;
  cursor: pointer;
}

.nav-item {
  width: 100%;
  min-height: 40px;
  padding: 0 12px;
  border-radius: 10px;
  color: #c2ccde;
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
  position: relative;
  transition: background 0.18s ease, color 0.18s ease;
}
.nav-item:focus-visible {
  outline: 2px solid #7c9bff;
  outline-offset: 2px;
}

.nav-item mat-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
  color: #ffffff;
  flex: 0 0 auto;
}

.nav-item span {
  color: inherit;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.app-shell.sidebar-collapsed .nav-item {
  width: 44px;
  min-height: 44px;
  margin: 0 auto;
  justify-content: center;
  padding: 0;
  gap: 0;
}

.app-shell.sidebar-collapsed .nav-item span,
.app-shell.sidebar-collapsed .nav-arrow,
.app-shell.sidebar-collapsed .submenu {
  display: none;
}

.app-shell.sidebar-collapsed .nav-flyout .nav-item span,
.app-shell.sidebar-collapsed .nav-flyout .nav-arrow {
  display: block;
}
.app-shell.sidebar-collapsed .nav-flyout .submenu {
  display: flex;
  flex-direction: column;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.07);
  color: #eaf1f9;
}

.nav-item:hover mat-icon {
  color: #ffffff;
}

.active-link {
  background: #162d66;
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(22, 45, 102, 0.45);
}

.active-link mat-icon {
  color: #ffffff;
}

.app-shell.sidebar-collapsed .active-link::before {
  content: "";
  position: absolute;
  left: -12px;
  top: 11px;
  width: 3px;
  height: 22px;
  border-radius: 0 3px 3px 0;
  background: #0d6efd;
}

.nav-arrow {
  margin-left: auto;
  font-size: 16px !important;
  width: 16px;
  height: 16px;
  opacity: 0.65;
  transition: transform 0.2s;
}

.sidebar-edge-toggle {
  position: absolute;
  top: 21px;
  right: -10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #161d2f;
  color: #c2ccde;
  border: 1px solid #e2e8f0;
  display: grid;
  place-items: center;
  cursor: pointer;
  z-index: 50;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 1px 0px 3px #111111;
}
.sidebar-edge-toggle mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  transition: transform 0.2s ease;
}
.sidebar-edge-toggle:hover {
  background: #162d66;
  color: #ffffff;
  border-color: #162d66;
  transform: scale(1.15);
}

.submenu {
  margin: 4px 0 6px 21px;
  padding-left: 9px;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.submenu.nested {
  margin: 0 0 2px 4px;
  border-left: none;
  padding-left: 6px;
}

.submenu-item {
  min-height: 34px;
  padding: 7px 10px;
  border-radius: 8px;
  color: #9fb2c9;
  font-size: 13.5px;
  font-weight: 500;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background 0.15s, color 0.15s;
}
.submenu-item:focus-visible {
  outline: 2px solid #7c9bff;
  outline-offset: -2px;
}

.submenu-item:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #c2ccde;
}

.submenu-item.active-link {
  background: #162d66;
  color: #ffffff;
  font-weight: 700;
  box-shadow: none;
}

.submenu > .submenu-item.group-toggle {
  color: #9fb2c9;
  font-size: 13.5px;
  font-weight: 500;
}
.submenu > .submenu-item.group-toggle:hover, .submenu > .submenu-item.group-toggle.open {
  color: #c2ccde;
  background: rgba(255, 255, 255, 0.05);
}
.submenu > .submenu-item.group-toggle .nav-arrow {
  font-size: 13px !important;
  width: 13px;
  height: 13px;
  opacity: 0.8;
}
.submenu > .submenu-item.group-toggle.open .nav-arrow {
  transform: rotate(180deg);
}

.sidebar-footer {
  padding: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
}

.app-shell.sidebar-collapsed .sidebar-footer {
  padding: 12px 8px;
}

.nav-item.danger {
  color: #e79a97;
}

.nav-item.danger mat-icon {
  color: #e79a97;
}

.nav-item.danger:hover {
  background: rgba(239, 68, 68, 0.13);
  color: #ffb9b4;
}
.nav-item.danger:hover mat-icon {
  color: #ffb9b4;
}

.app-main {
  min-width: 0;
  width: 100%;
  height: 100vh;
  display: grid;
  grid-template-rows: 64px minmax(0, 1fr);
  overflow: hidden;
}

.app-topbar {
  height: 64px;
  width: 100%;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  backdrop-filter: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 24px;
  z-index: 10;
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 220px;
}

.page-title {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.page-title h1 {
  margin: 0;
  color: #0a0f24;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.page-title span {
  display: block;
  margin: 0;
  color: #7e93ad;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  line-height: 1;
  order: -1;
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.icon-button {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #475569;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: background 0.18s ease;
}
.icon-button:focus-visible {
  outline: 2px solid #7c9bff;
  outline-offset: 2px;
}

.icon-button:hover {
  background: #f1f5f9;
}

.company-pill,
.user-pill {
  height: 44px;
  border: 1px solid transparent;
  background: #ffffff;
  border-radius: 12px;
  color: #0a0f24;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 10px 5px 5px;
  cursor: pointer;
  transition: background 0.18s, border-color 0.18s;
}

.company-pill:hover,
.user-pill:hover {
  background: #f8fafc;
  border-color: #e2e8f0;
}

.company-pill span {
  max-width: 170px;
  color: #0a0f24;
  font-size: 13px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.company-pill img,
.user-pill img {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
}

.user-pill div {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  text-align: left;
  gap: 1px;
}

.user-pill strong {
  text-transform: capitalize;
  color: #0a0f24;
  font-size: 13.5px;
  font-weight: 700;
}

.user-pill small {
  margin: 0;
  color: #475569;
  font-size: 11.5px;
  font-weight: 500;
}

.user-pill mat-icon {
  color: #475569;
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.app-content {
  position: relative;
  min-width: 0;
  min-height: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f1f5f9 !important;
}

.app-content ion-router-outlet {
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
}

.app-content ion-router-outlet > .ion-page {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
  min-width: 0 !important;
  overflow: hidden !important;
}

.app-content ion-content {
  --background: transparent;
  --padding-top: 28px;
  --padding-start: 32px;
  --padding-end: 32px;
  --padding-bottom: 28px;
}

.app-content ion-content::part(scroll) {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.topbar-search-wrap {
  position: relative;
  max-width: 480px;
  min-width: 260px;
  flex: 1;
}

.topbar-search {
  height: 40px;
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.topbar-search.search-active {
  border-color: #7c9bff;
  box-shadow: 0 0 0 3px rgba(22, 45, 102, 0.12);
}

.topbar-search mat-icon {
  color: #64748b;
}

.topbar-search input {
  width: 100%;
  border: 0;
  outline: 0;
  font-size: 14px;
  color: #0a0f24;
  background: transparent;
  font-family: inherit;
}
.topbar-search input::placeholder {
  color: #94a3b8;
}

.topbar-search kbd {
  border: 1px solid #e2e8f0;
  border-bottom-width: 2px;
  border-radius: 6px;
  padding: 2px 7px;
  font-size: 11px;
  color: #64748b;
  background: #f8fafc;
  white-space: nowrap;
}

.search-clear {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  display: grid;
  place-items: center;
  cursor: pointer;
}
.search-clear:hover {
  background: #f1f5f9;
  color: #0a0f24;
}
.search-clear mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}

.search-panel {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 20px 50px rgba(10, 15, 36, 0.14);
}

.search-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px 8px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.search-panel-header small {
  font-size: 11px;
  color: #94a3b8;
  text-transform: none;
  letter-spacing: 0;
}

.search-result {
  width: 100%;
  min-height: 52px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  cursor: pointer;
  text-align: left;
  transition: background 0.16s ease;
}
.search-result:hover {
  background: #f1f5f9;
}

.result-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(22, 45, 102, 0.08);
  color: #162d66;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
}
.result-icon mat-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
}

.result-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.result-copy strong {
  color: #0a0f24;
  font-size: 13.5px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.result-copy span {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.result-arrow {
  margin-left: auto;
  color: #94a3b8;
  width: 18px;
  height: 18px;
  font-size: 18px;
}

.search-empty {
  min-height: 120px;
  padding: 24px;
  border-radius: 10px;
  background: #f8fafc;
  display: grid;
  place-items: center;
  text-align: center;
  color: #64748b;
}
.search-empty mat-icon {
  color: #94a3b8;
  margin-bottom: 8px;
}
.search-empty strong {
  display: block;
  color: #0a0f24;
  font-size: 14px;
  font-weight: 700;
}
.search-empty span {
  margin-top: 4px;
  max-width: 320px;
  font-size: 12px;
}

.nav-flyout {
  position: fixed;
  left: 76px;
  width: 252px;
  max-height: calc(100vh - 24px);
  overflow-y: auto;
  background: #10162e;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 24px 60px rgba(3, 10, 20, 0.55);
  z-index: 55;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.nav-flyout .flyout-title {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #7e93ad;
  padding: 6px 10px 4px;
}

.nav-tooltip {
  position: fixed;
  left: 78px;
  transform: translateY(-50%);
  background: #0a0f24;
  color: #fff;
  font-size: 12.5px;
  font-weight: 600;
  padding: 7px 11px;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(4, 10, 20, 0.4);
  z-index: 60;
  pointer-events: none;
  white-space: nowrap;
}

@media (max-width: 1180px) {
  .topbar-search {
    max-width: 360px;
  }
  .company-pill span,
  .user-pill div {
    display: none;
  }
}
@media (max-width: 760px) {
  .app-shell,
  .app-shell.sidebar-collapsed {
    grid-template-columns: 1fr;
  }
  .app-sidebar {
    position: fixed;
    left: 0;
    top: 0;
    transform: translateX(0);
  }
  .app-shell.sidebar-collapsed .app-sidebar {
    transform: translateX(-100%);
  }
  .topbar-search {
    display: none;
  }
  .app-content ion-content {
    --padding-top: 14px;
    --padding-start: 14px;
    --padding-end: 14px;
    --padding-bottom: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,yCAAA;EACA,cAAA;AACF;;AAaA;EACE,aAAA;EACA,2CAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,0CAAA;AAVF;;AAgBA;EACE,YA3BU;EA4BV,gBA5BU;EA6BV,aAAA;EACA,mBA5BO;EA6BP,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,kGAAA;AAbF;;AAgBA;EACE,WAzCoB;EA0CpB,eA1CoB;AA6BtB;;AAgBA;EACE,YAAA;EACA,eAAA;EACA,kDAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAbF;;AAgBA;EACE,UAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBA9DW;EA+DX,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAbF;;AAgBA;EACE,cA1Ee;AA6DjB;;AAgBA;EACE,cAAA;AAbF;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AAbF;;AAgBA;EACE,cAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,cAjGe;EAkGf,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAbF;AAeE;EAAuB,UAAA;AAZzB;AAaE;EAA6B,qCAAA;EAAuC,kBAAA;AATtE;AAUE;EAA6B,uBAAA;AAP/B;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,kBAAA;AAPF;;AAUA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,oCAAA;EACA,eAAA;AAPF;;AAUA;;EAEE,SAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;AAPF;;AAUA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cArJS;EAsJT,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,mDAAA;AAPF;AASE;EAAkB,0BAAA;EAA4B,mBAAA;AALhD;;AAQA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AALF;;AAQA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AALF;;AAQA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,UAAA;EACA,MAAA;AALF;;AAQA;;;EAGE,aAAA;AALF;;AASE;;EAEE,cAAA;AANJ;AASE;EACE,aAAA;EACA,sBAAA;AAPJ;;AAWA;EACE,qCAAA;EACA,cAAA;AARF;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,mBAtNW;EAuNX,cAAA;EACA,8CAAA;AARF;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;AARF;;AAWA;EACE,iBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;AARF;;AAcA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBA9PO;EA+PP,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,kDAAA;EACA,+BAAA;AAXF;AAaE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;AAXJ;AAcE;EACE,mBA/QS;EAgRT,cAAA;EACA,qBAjRS;EAkRT,sBAAA;AAZJ;;AAmBA;EACE,sBAAA;EACA,iBAAA;EACA,gDAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAhBF;;AAmBA;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;AAhBF;;AAmBA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yCAAA;AAhBF;AAkBE;EAAkB,0BAAA;EAA4B,oBAAA;AAdhD;;AAiBA;EACE,qCAAA;EACA,cAAA;AAdF;;AAiBA;EACE,mBAjUW;EAkUX,cAAA;EACA,gBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;AAdF;AAgBE;EACS,cAAA;EAAgB,qCAAA;AAb3B;AAeE;EACE,0BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAbJ;AAeE;EAAoB,yBAAA;AAZtB;;AAkBA;EACE,aAAA;EACA,+CAAA;EACA,cAAA;AAfF;;AAkBA;EACE,iBAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,mCAAA;EACA,cAAA;AAfF;AAiBE;EAAW,cAAA;AAdb;;AAoBA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uCAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,SAAA;EACA,cAzZI;EA0ZJ,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,SAAA;EACA,cAzae;EA0af,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,SAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iCAAA;AAjBF;AAmBE;EAAkB,0BAAA;EAA4B,mBAAA;AAfhD;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;;EAEE,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,cA9cI;EA+cJ,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,eAAA;EACA,gDAAA;AAfF;;AAkBA;;EAEE,mBAAA;EACA,qBA3de;AA4cjB;;AAkBA;EACE,gBAAA;EACA,cA/dI;EAgeJ,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAfF;;AAkBA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,QAAA;AAfF;;AAkBA;EACE,0BAAA;EACA,cAzfI;EA0fJ,iBAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,SAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAfF;;AAqBA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAlBF;;AAqBA;EACE,6BAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,eAAA;EACA,sBAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,0DAAA;AAlBF;;AAqBA;EACE,qBAAA;EACA,6CAAA;AAlBF;;AAqBA;EAA0B,cAAA;AAjB1B;;AAmBA;EACE,WAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,cAvlBI;EAwlBJ,uBAAA;EACA,oBAAA;AAhBF;AAkBE;EAAiB,cAAA;AAfnB;;AAkBA;EACE,yBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAfF;AAiBE;EAAU,mBAAA;EAAqB,cApnB3B;AAumBN;AAeE;EAAW,WAAA;EAAa,YAAA;EAAc,eAAA;AAVxC;;AAaA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAVF;;AAaA;EACE,eAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;AAVF;;AAaA;EACE,WAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAVF;AAYE;EAAU,mBAAA;AATZ;;AAYA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AATF;AAWE;EAAW,WAAA;EAAa,YAAA;EAAc,eAAA;AANxC;;AASA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AANF;;AASA;EACE,cA9rBI;EA+rBJ,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AANF;;AASA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AANF;;AASA;EACE,iBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AANF;;AASA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AANF;AAQE;EAAW,cAAA;EAAgB,kBAAA;AAJ7B;AAME;EACE,cAAA;EACA,cAtuBE;EAuuBF,eAAA;EACA,gBAAA;AAJJ;AAOE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AALJ;;AAYA;EACE,eAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,mBAAA;EACA,aAAA;EACA,6CAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cA9wBe;EA+wBf,qBAAA;AATF;;AAYA;EACE,eAAA;EACA,UAAA;EACA,2BAAA;EACA,mBAnxBI;EAoxBJ,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2CAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;AATF;;AAeA;EACE;IAAiB,gBAAA;EAXjB;EAaA;;IACiB,aAAA;EAVjB;AACF;AAYA;EACE;;IAC+B,0BAAA;EAT/B;EAWA;IACE,eAAA;IACA,OAAA;IACA,MAAA;IACA,wBAAA;EATF;EAYA;IACE,4BAAA;EAVF;EAaA;IAAiB,aAAA;EAVjB;EAYA;IACE,mBAAA;IACA,qBAAA;IACA,mBAAA;IACA,sBAAA;EAVF;AACF","sourcesContent":[":host {\n  display: block;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  font-family: \"Manrope\", Arial, sans-serif;\n  color: #0a0f24;\n}\n\n$ease-brand: cubic-bezier(0.16, 1, 0.3, 1);\n$sidebar-w: 264px;\n$sidebar-w-collapsed: 68px;\n$nav-bg: #161d2f;\n$nav-active: #162d66;\n$nav-text: #c2ccde;\n$nav-text-muted: #7e93ad;\n$hairline-dark: rgba(255, 255, 255, 0.08);\n$hairline-light: #e2e8f0;\n$ink: #0a0f24;\n\n.app-shell {\n  display: grid;\n  grid-template-columns: $sidebar-w minmax(0, 1fr);\n  width: 100vw;\n  height: 100vh;\n  background: #f1f5f9;\n  overflow: hidden;\n}\n\n.app-shell.sidebar-collapsed {\n  grid-template-columns: $sidebar-w-collapsed minmax(0, 1fr);\n}\n\n// ------------------------------------------------------------\n// Sidebar\n// ------------------------------------------------------------\n.app-sidebar {\n  width: $sidebar-w;\n  min-width: $sidebar-w;\n  height: 100vh;\n  background: $nav-bg; \n  border-right: 0;\n  box-shadow: none;\n  display: flex;\n  flex-direction: column;  \n  overflow: visible; \n  position: relative; \n  z-index: 20;\n  transition: width 0.3s $ease-brand, min-width 0.3s $ease-brand;\n}\n\n.app-shell.sidebar-collapsed .app-sidebar {\n  width: $sidebar-w-collapsed;\n  min-width: $sidebar-w-collapsed;\n}\n\n.sidebar-brand {\n  height: 64px;\n  padding: 0 15px;\n  border-bottom: 1px solid $hairline-dark;\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  flex-shrink: 0;\n}\n\n.app-shell.sidebar-collapsed .sidebar-brand {\n  padding: 0;\n  justify-content: center;\n}\n\n.brand-logo {\n  width: 36px;\n  height: 36px;\n  border-radius: 11px;\n  background: $nav-active; \n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  flex: 0 0 auto;\n}\n\n.brand-logo mat-icon {\n  width: 22px;\n  height: 22px;\n  color: #ffffff;\n}\n\n.menu-button {\n  color: $nav-text-muted;\n}\n\n.icon-button:hover .menu-button {\n  color: #ffffff;\n}\n\n.brand-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.1;\n  min-width: 0;\n}\n\n.brand-text strong {\n  color: #ffffff;\n  font-size: 17px;\n  letter-spacing: -0.02em;\n  white-space: nowrap;\n}\n\n.brand-text span {\n  margin-top: 3px;\n  color: $nav-text-muted;\n  font-size: 9px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 14px 12px;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.16); border-radius: 3px; }\n  &::-webkit-scrollbar-track { background: transparent; }\n}\n\n.app-shell.sidebar-collapsed .sidebar-nav {\n  padding: 14px 12px;\n}\n\n.nav-group {\n  margin-bottom: 4px;\n  position: relative;\n}\n\n.app-shell.sidebar-collapsed .nav-group + .nav-group::before {\n  content: \"\";\n  display: block;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.1);\n  margin: 6px 8px;\n}\n\n.nav-item,\n.submenu-item {\n  border: 0;\n  background: transparent;\n  font: inherit;\n  cursor: pointer;\n}\n\n.nav-item {\n  width: 100%;\n  min-height: 40px;\n  padding: 0 12px;\n  border-radius: 10px;\n  color: $nav-text;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-align: left;\n  position: relative;\n  transition: background 0.18s ease, color 0.18s ease;\n\n  &:focus-visible { outline: 2px solid #7c9bff; outline-offset: 2px; }\n}\n\n.nav-item mat-icon {\n  width: 20px;\n  height: 20px;\n  font-size: 20px;\n  color: #ffffff;\n  flex: 0 0 auto;\n}\n\n.nav-item span {\n  color: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n}\n\n.app-shell.sidebar-collapsed .nav-item {\n  width: 44px;\n  min-height: 44px;\n  margin: 0 auto;\n  justify-content: center;\n  padding: 0;\n  gap: 0;\n}\n\n.app-shell.sidebar-collapsed .nav-item span,\n.app-shell.sidebar-collapsed .nav-arrow,\n.app-shell.sidebar-collapsed .submenu {\n  display: none;\n}\n\n.app-shell.sidebar-collapsed .nav-flyout {\n  .nav-item span,\n  .nav-arrow {\n    display: block; \n  }\n\n  .submenu {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.nav-item:hover {\n  background: rgba(255, 255, 255, 0.07);\n  color: #eaf1f9;\n}\n\n.nav-item:hover mat-icon {\n  color: #ffffff;\n}\n\n.active-link {\n  background: $nav-active;\n  color: #ffffff;\n  box-shadow: 0 6px 16px rgba(22, 45, 102, 0.45);\n}\n\n.active-link mat-icon {\n  color: #ffffff;\n}\n\n.app-shell.sidebar-collapsed .active-link::before {\n  content: \"\";\n  position: absolute;\n  left: -12px;\n  top: 11px;\n  width: 3px;\n  height: 22px;\n  border-radius: 0 3px 3px 0;\n  background: #0d6efd;\n}\n\n.nav-arrow {\n  margin-left: auto;\n  font-size: 16px !important;\n  width: 16px;\n  height: 16px;\n  opacity: 0.65;\n  transition: transform 0.2s;\n}\n\n// ------------------------------------------------------------\n// Botón Flotante del Borde (Toggle Sidebar)\n// ------------------------------------------------------------\n.sidebar-edge-toggle {\n  position: absolute;\n  top: 21px;  \n  right: -10px;       \n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: $nav-bg; \n  color: #c2ccde;\n  border: 1px solid $hairline-light; \n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  z-index: 50;\n  transition: all 0.2s $ease-brand;\n  box-shadow: 1px 0px 3px #111111;\n\n  mat-icon {\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n    transition: transform 0.2s ease;\n  }\n\n  &:hover {\n    background: $nav-active;\n    color: #ffffff;\n    border-color: $nav-active;\n    transform: scale(1.15);\n  }\n}\n\n// ------------------------------------------------------------\n// Submenú\n// ------------------------------------------------------------\n.submenu {\n  margin: 4px 0 6px 21px;\n  padding-left: 9px;\n  border-left: 1px solid rgba(255, 255, 255, 0.12);\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.submenu.nested {\n  margin: 0 0 2px 4px;\n  border-left: none;\n  padding-left: 6px;\n}\n\n.submenu-item {\n  min-height: 34px;\n  padding: 7px 10px;\n  border-radius: 8px;\n  color: #9fb2c9;\n  font-size: 13.5px;\n  font-weight: 500;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: background 0.15s, color 0.15s;\n\n  &:focus-visible { outline: 2px solid #7c9bff; outline-offset: -2px; }\n}\n\n.submenu-item:hover {\n  background: rgba(255, 255, 255, 0.06);\n  color: #c2ccde;\n}\n\n.submenu-item.active-link {\n  background: $nav-active;\n  color: #ffffff;\n  font-weight: 700;\n  box-shadow: none;\n}\n\n.submenu > .submenu-item.group-toggle {\n  color: #9fb2c9;\n  font-size: 13.5px;\n  font-weight: 500;\n\n  &:hover,\n  &.open { color: #c2ccde; background: rgba(255, 255, 255, 0.05); }\n\n  .nav-arrow {\n    font-size: 13px !important;\n    width: 13px;\n    height: 13px;\n    opacity: 0.8;\n  }\n  &.open .nav-arrow { transform: rotate(180deg); }\n}\n\n// ------------------------------------------------------------\n// Footer del sidebar\n// ------------------------------------------------------------\n.sidebar-footer {\n  padding: 12px;\n  border-top: 1px solid $hairline-dark;\n  flex-shrink: 0;\n}\n\n.app-shell.sidebar-collapsed .sidebar-footer {\n  padding: 12px 8px;\n}\n\n.nav-item.danger {\n  color: #e79a97;\n}\n\n.nav-item.danger mat-icon {\n  color: #e79a97;\n}\n\n.nav-item.danger:hover {\n  background: rgba(239, 68, 68, 0.13);\n  color: #ffb9b4;\n\n  mat-icon { color: #ffb9b4; }\n}\n\n// ------------------------------------------------------------\n// Main + Topbar\n// ------------------------------------------------------------\n.app-main {\n  min-width: 0;\n  width: 100%;\n  height: 100vh;\n  display: grid;\n  grid-template-rows: 64px minmax(0, 1fr);\n  overflow: hidden;\n}\n\n.app-topbar {\n  height: 64px;\n  width: 100%;\n  background: #ffffff;\n  border-bottom: 1px solid $hairline-light;\n  backdrop-filter: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 0 24px;\n  z-index: 10;\n}\n\n.topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 220px;\n}\n\n.page-title {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.page-title h1 {\n  margin: 0;\n  color: $ink;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.page-title span {\n  display: block;\n  margin: 0;\n  color: $nav-text-muted;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  line-height: 1;\n  order: -1; \n}\n\n.topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.icon-button {\n  width: 36px;\n  height: 36px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #475569;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  transition: background 0.18s ease;\n\n  &:focus-visible { outline: 2px solid #7c9bff; outline-offset: 2px; }\n}\n\n.icon-button:hover {\n  background: #f1f5f9;\n}\n\n.company-pill,\n.user-pill {\n  height: 44px;\n  border: 1px solid transparent;\n  background: #ffffff;\n  border-radius: 12px;\n  color: $ink;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 5px 10px 5px 5px;\n  cursor: pointer;\n  transition: background 0.18s, border-color 0.18s;\n}\n\n.company-pill:hover,\n.user-pill:hover {\n  background: #f8fafc;\n  border-color: $hairline-light;\n}\n\n.company-pill span {\n  max-width: 170px;\n  color: $ink;\n  font-size: 13px;\n  font-weight: 700;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.company-pill img,\n.user-pill img {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.user-pill div {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.1;\n  text-align: left;\n  gap: 1px;\n}\n\n.user-pill strong {\n  text-transform: capitalize;\n  color: $ink;\n  font-size: 13.5px;\n  font-weight: 700;\n}\n\n.user-pill small {\n  margin: 0;\n  color: #475569;\n  font-size: 11.5px;\n  font-weight: 500;\n}\n\n.user-pill mat-icon {\n  color: #475569;\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n// ------------------------------------------------------------\n// Contenido\n// ------------------------------------------------------------\n.app-content {\n  position: relative;\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: #f1f5f9 !important;\n}\n\n.app-content ion-router-outlet {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.app-content ion-router-outlet > .ion-page {\n  position: absolute !important;\n  inset: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  min-width: 0 !important;\n  overflow: hidden !important;\n}\n\n.app-content ion-content {\n  --background: transparent;\n  --padding-top: 28px;\n  --padding-start: 32px;\n  --padding-end: 32px;\n  --padding-bottom: 28px;\n}\n\n.app-content ion-content::part(scroll) {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.topbar-search-wrap {\n  position: relative;\n  max-width: 480px;\n  min-width: 260px;\n  flex: 1;\n}\n\n.topbar-search {\n  height: 40px;\n  width: 100%;\n  border: 1px solid $hairline-light;\n  border-radius: 10px;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 12px;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.topbar-search.search-active {\n  border-color: #7c9bff;\n  box-shadow: 0 0 0 3px rgba(22, 45, 102, 0.12);\n}\n\n.topbar-search mat-icon { color: #64748b; }\n\n.topbar-search input {\n  width: 100%;\n  border: 0;\n  outline: 0;\n  font-size: 14px;\n  color: $ink;\n  background: transparent;\n  font-family: inherit;\n\n  &::placeholder { color: #94a3b8; }\n}\n\n.topbar-search kbd {\n  border: 1px solid $hairline-light;\n  border-bottom-width: 2px;\n  border-radius: 6px;\n  padding: 2px 7px;\n  font-size: 11px;\n  color: #64748b;\n  background: #f8fafc;\n  white-space: nowrap;\n}\n\n.search-clear {\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748b;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n\n  &:hover { background: #f1f5f9; color: $ink; }\n\n  mat-icon { width: 18px; height: 18px; font-size: 18px; }\n}\n\n.search-panel {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  padding: 8px;\n  border: 1px solid $hairline-light;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 20px 50px rgba(10, 15, 36, 0.14);\n}\n\n.search-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 8px 8px;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.search-panel-header small {\n  font-size: 11px;\n  color: #94a3b8;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.search-result {\n  width: 100%;\n  min-height: 52px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 10px;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.16s ease;\n\n  &:hover { background: #f1f5f9; }\n}\n\n.result-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: rgba(22, 45, 102, 0.08);\n  color: #162d66;\n  display: grid;\n  place-items: center;\n  flex: 0 0 auto;\n\n  mat-icon { width: 20px; height: 20px; font-size: 20px; }\n}\n\n.result-copy {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.result-copy strong {\n  color: $ink;\n  font-size: 13.5px;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.result-copy span {\n  margin-top: 2px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.result-arrow {\n  margin-left: auto;\n  color: #94a3b8;\n  width: 18px;\n  height: 18px;\n  font-size: 18px;\n}\n\n.search-empty {\n  min-height: 120px;\n  padding: 24px;\n  border-radius: 10px;\n  background: #f8fafc;\n  display: grid;\n  place-items: center;\n  text-align: center;\n  color: #64748b;\n\n  mat-icon { color: #94a3b8; margin-bottom: 8px; }\n\n  strong {\n    display: block;\n    color: $ink;\n    font-size: 14px;\n    font-weight: 700;\n  }\n\n  span {\n    margin-top: 4px;\n    max-width: 320px;\n    font-size: 12px;\n  }\n}\n\n// ------------------------------------------------------------\n// Flyout + tooltip (submenú con sidebar colapsado)\n// ------------------------------------------------------------\n.nav-flyout {\n  position: fixed; \n  left: $sidebar-w-collapsed + 8px;\n  width: 252px;\n  max-height: calc(100vh - 24px);\n  overflow-y: auto;\n  background: #10162e;\n  border: 1px solid rgba(255, 255, 255, 0.13);\n  border-radius: 12px;\n  padding: 10px;\n  box-shadow: 0 24px 60px rgba(3, 10, 20, 0.55);\n  z-index: 55;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.nav-flyout .flyout-title {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: $nav-text-muted;\n  padding: 6px 10px 4px;\n}\n\n.nav-tooltip {\n  position: fixed;\n  left: $sidebar-w-collapsed + 10px;\n  transform: translateY(-50%);\n  background: $ink;\n  color: #fff;\n  font-size: 12.5px;\n  font-weight: 600;\n  padding: 7px 11px;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(4, 10, 20, 0.4);\n  z-index: 60;\n  pointer-events: none;\n  white-space: nowrap;\n}\n\n// ------------------------------------------------------------\n// Responsive\n// ------------------------------------------------------------\n@media (max-width: 1180px) {\n  .topbar-search { max-width: 360px; }\n\n  .company-pill span,\n  .user-pill div { display: none; }\n}\n\n@media (max-width: 760px) {\n  .app-shell,\n  .app-shell.sidebar-collapsed { grid-template-columns: 1fr; }\n\n  .app-sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    transform: translateX(0);\n  }\n\n  .app-shell.sidebar-collapsed .app-sidebar {\n    transform: translateX(-100%);\n  }\n\n  .topbar-search { display: none; }\n\n  .app-content ion-content {\n    --padding-top: 14px;\n    --padding-start: 14px;\n    --padding-end: 14px;\n    --padding-bottom: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
